// src/utils/errorMessage.js
//
// Преобразует ошибку API в человеческое локализованное сообщение.
//
// Использование:
//   import { errorMessage } from '../utils/errorMessage';
//   try { ... } catch (e) { show(errorMessage(e, t), 'error'); }
//
// Если у ошибки есть netErrorKey (timeout/offline/server) — переводит через i18n.
// Иначе возвращает оригинальное сообщение (ошибка валидации, бизнес-логики и т.д.).

export function errorMessage(error, t) {
  if (!error) return '';
  // Сетевая ошибка с типизацией
  if (error.netErrorKey) {
    return t(error.netErrorKey);
  }
  // Серверная ошибка (4xx) — текст с бэка как есть
  return error.message || t('common.error');
}
